import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    version: '',
    job_id: '',
    completed_job: ''
  },
  getters: {
    versioin (state) {
      return state.version
    }
  },
  mutations: {
    updateVersion (state, ver) {
      state.version = ver
    },
    updateJobId (state, ver) {
      state.job_id = ver
    },
    updateCompletedJob (state, job) {
      state.completed_job = job
    }
  },
  actions: {
  },
  modules: {
  },
  plugins: [createPersistedState({
    key: '3b9416c1-7713-4738-82fd-68f453bd8688'
  })]
})
